const en = require('./languages/en.json');
const de = require('./languages/de.json');
const es = require('./languages/es-ES.json');
const fr = require('./languages/fr.json');
const it = require('./languages/it.json');
const ja = require('./languages/ja.json');
const ko = require('./languages/ko.json');
const nl = require('./languages/nl.json');
const pt = require('./languages/pt-PT.json');
const ru = require('./languages/ru.json');
const tr = require('./languages/tr.json');
const zh = require('./languages/zh-CN.json');

exports.data = {
  en,
  de,
  es,
  fr,
  it,
  ja,
  ko,
  nl,
  pt,
  ru,
  tr,
  zh,
};



// WEBPACK FOOTER //
// ./src/helper/localization/localizationData.js